import React from "react";
import Player from "../../../../components/tot/totGame/players";
import classes from "./styles.module.scss";

const PlayerList = (props) => {
  const { playersList, playersListLabel, deletePlayer } = props;
  return (
    <div className={classes.players}>
      {/* <div className={classes.titleWrapper}>
        <p className={cx("text-yellow", classes.title)}>{playersListLabel}</p>
      </div> */}
      <div className={classes.list}>
        <div className={classes.listWrapper}>
          <div className={classes.listHolder}>
            {playersList.map((data, index) => (
              <Player key={index} {...data} deletePlayer={deletePlayer} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlayerList;
